import ClientNotificationInterface from '../../interfaces/client/Notification'
import ErrorModel from '../../models/Error'
import getLabels from '../getLabels'
import buildGenericNotification from './buildGenericNotification'

const buildGenericNotificationFromErrors = (
  errors: ErrorModel[]
): ClientNotificationInterface => {
  var notifications: ClientNotificationInterface[] = []

  errors.map((error: ErrorModel) => {
    if (
      !!error.code &&
      (error.code as string).indexOf('TOO_CLOSE_TO_DEPARTURE') >= 0 // due to typing this needs to be converted for compiler
    ) {
      notifications.push(buildGenericNotification(getLabels(error.code)))
    }
  })

  if (!notifications.length)
    notifications.push(
      buildGenericNotification(
        getLabels('error_update_edit_passengers_failed_partially')
      )
    )

  return notifications[0]
}
export default buildGenericNotificationFromErrors
